module.exports = __webpack_public_path__ + "img/bg-jason-merwe.8e84a619.jpg";